<template>
  <section class="giftee-columns">
    <PageHeadlineWithLink
      class="card-designs__head"
      title="gifteeコラム一覧"
      link-title="戻る"
      @click-link="onClickBack"
    />
    <div class="giftee-columns__body">
      <div class="feedback">
        <transition name="fade" @enter="enterErrorFeedback">
          <FeedbackError v-if="showableErrorFeedback" :message="errorMessage" />
        </transition>
      </div>
      <Loading v-if="isLoading" />
      <!-- 特集一覧と同じデザインのため、同じコンポーネントを使用。 -->
      <SpecialBoxes v-else :specials="gifteeColumns" />
      <Pagination
        :current-page="currentPage"
        :total-pages="totalPages"
        @clicked="onClickPageLink"
      />
    </div>
    <div class="giftee-columns__footer">
      <div class="giftee-columns__back-to-root">
        <a
          href="/"
          class="giftee-columns__back-to-root__link tl-link-chevron-back--left"
        >
          gifteeトップへ戻る
        </a>
      </div>
      <div class="giftee-columns__back-to-top">
        <span class="text-link-to-top" @click.self="onClickLinkToTop">
          ページトップへ ▲
        </span>
      </div>
    </div>
  </section>
</template>
<script>
import axios from 'axios'
import dayjs from 'dayjs'
import FeedbackError from '../../atoms/feedbacks/feedback-error.vue'
import Loading from '../../atoms/loadings/Loading.vue'
import Pagination from '../../organism/paginations/Pagination.vue'
import SpecialBoxes from '../../organism/specials/SpecialBoxes.vue'
import PageHeadlineWithLink from '../../molecules/headlines/PageHeadlineWithLink.vue'
import url from 'url'
import qs from 'qs'

export default {
  components: {
    FeedbackError,
    Loading,
    SpecialBoxes,
    Pagination,
    PageHeadlineWithLink
  },
  data() {
    return {
      gifteeColumns: [],
      isLoading: false,
      showableErrorFeedback: false,
      errorMessage: '',
      currentPage: 1,
      totalPages: 1
    }
  },
  mounted() {
    this.initializeParams()
    this.getSpecials(this.currentPage)

    // NOTE: ブラウザバック・フォワード時の更新処理
    window.onpopstate = async function() {
      this.initializeParams()
      this.getSpecials(this.currentPage)
    }.bind(this)
  },
  methods: {
    onClickBack() {
      window.history.back()
    },
    initializeParams() {
      const urlQuery = url.parse(location.href).query
      if (!urlQuery) {
        this.currentPage = 1
        return
      }
      const parsed = qs.parse(urlQuery)
      this.currentPage = parsed.page ? Number(parsed.page) : 1
    },
    updateUrlFromParams() {
      history.pushState(
        '',
        '',
        this.currentPage <= 1
          ? '/announcements/giftee_columns'
          : `/announcements/giftee_columns?page=${this.currentPage}`
      )
    },
    async getSpecials(page) {
      this.isLoading = true
      try {
        const res = await axios.get(
          `/api/v1/pickup/announcements/giftee_columns?page=${page ? page : 1}`
        )
        const { current_page, total_pages } = res.data.meta
        this.currentPage = current_page
        this.totalPages = total_pages
        this.gifteeColumns = res.data.data
          .map(gifteeColumn => gifteeColumn.attributes)
          .map(gifteeColumn => ({
            id: gifteeColumn.id,
            title: gifteeColumn.title,
            startedAt: dayjs(gifteeColumn.started_at).format('YYYY/MM/DD'),
            imageUrl: gifteeColumn.list_image_url
          }))
      } catch (error) {
        this.errorMessage =
          error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : '情報の取得に失敗しました。しばらく経ってから再度アクセスしてください'
        this.showableErrorFeedback = true
      }
      this.isLoading = false
    },
    enterErrorFeedback() {
      setTimeout(() => {
        this.showableErrorFeedback = false
      }, 3000)
    },
    async onClickPageLink(page) {
      this.scrollToTop()
      await this.getSpecials(page)
      this.updateUrlFromParams()
    },
    onClickLinkToTop() {
      this.scrollToTop()
    },
    scrollToTop() {
      window.scrollTo({ top, behavior: 'smooth' })
    }
  }
}
</script>
<style lang="scss" scoped>
.container {
  .giftee-columns {
    overflow: hidden;

    &__head {
      padding: 16px 24px;
      margin: 0;
      background-color: $white;
    }

    &__title {
      @extend %title;

      max-width: 840px;
      text-align: left;
      margin: auto;
    }

    &__body {
      margin-top: 16px;
      background-color: $white;
      padding-top: 16px;
    }

    &__back-to-root {
      padding: 24px 0 56px 0;
      margin: auto;
      font-size: 1.6rem;
      line-height: 1.6;
      text-align: left;
      width: 840px;

      &__link {
        color: $link;
        background-color: transparent;
      }
    }

    &__back-to-top {
      margin: auto;
      padding: 16px 0;
      background-color: $gray-2;

      .text-link-to-top {
        display: inline;
      }
    }
  }
}
</style>
